
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFormSetById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formSetId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantIdOrCompare"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantIdFilterInput"}}}},"defaultValue":{"kind":"ListValue","values":[]},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"formSetObj"},"name":{"kind":"Name","value":"getFormSetById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"formSetId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formSetId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantIdOrCompare"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantIdOrCompare"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formSetId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"published"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPrimary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenantId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"forms"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formSetFormId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formSetId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenantId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"form"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"version"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isScoreable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"formTypeId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"surveyType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenantId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"iconName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"calcFunctionId"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":791}};
    doc.loc.source = {"body":"query getFormSetById($formSetId: String!, $tenantIdOrCompare: [TenantIdFilterInput!] = []) {\n    formSetObj: getFormSetById(formSetId: $formSetId, tenantIdOrCompare: $tenantIdOrCompare) {\n        formSetId\n        name\n        published\n        formTypeId\n        lastUpdated\n        isPrimary\n        tenantId\n        forms {\n            formSetFormId\n            formSetId\n            formId\n            formVersion\n            order\n            tenantId\n            form {\n                formId\n                version\n                title\n                actions\n                isScoreable\n                formTypeId\n                surveyType\n                tenantId\n                cssClasses\n                iconName\n                calcFunctionId\n            }\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getFormSetById"] = oneQuery(doc, "getFormSetById");
        
